import React from "react"
import { SelectSeeker } from "@ui-seeker/core"

import { fuelPolicy } from "@signals"


export default function AppCommonFiltersFuelPolicySelect({ ...props }) {
	return <SelectSeeker
		label="Fuel Policy"
		value={fuelPolicy.value}
		isClearable
		onChange={e => fuelPolicy.value = e.target.value}
		placeholder="Select fuel policy"
		options={[
			{ label: 'Full/Empty', value: 'EUR' },
			{ label: 'Full/Full', value: 'GBP' }
		]}
		{...props}
	/>
}